<template>
  <div class="centerWidth">
    <div class="tag_position d-flex d-align-center">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <span>修改个人信息</span>
    </div>
    <div class="dynamic-wrap">
      <el-form ref="form" :model="form" label-position="top">
        <div class="d-flex d-just-between">
          <el-form-item label="姓名">
            <el-input style="width: 350px;" v-model="form.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-select style="width: 350px;" v-model="form.sex" placeholder="请选择性别">
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input style="width: 350px" v-model="form.idcard" disabled></el-input>
          </el-form-item>
        </div>
        <div class="d-flex d-just-between">
          <el-form-item label="邮箱">
            <el-input style="width: 350px;" v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input style="width: 350px;" v-model="form.password" type="password"></el-input>
          </el-form-item>
          <el-form-item label="所学科目">
            <div class="kemu">{{ subject_names.join('，') }}</div>
          </el-form-item>
        </div>

        <el-form-item class="d-just-center d-flex">
          <el-button type="primary" style="background: #2257ab" @click="onSubmit">立即修改</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  centerInfo,
  editInfo
} from "@/api/index";
import router from "../router";

export default {
  name: "About",
  data() {
    return {
      form: {
        name: '',
        sex: 1,
        idcard: '',
        email: '',
        password: '',
      },
      subject_names: []
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      let ajaxData = {}
      centerInfo(ajaxData).then(res => {
        if (res.code == 1) {
          this.form.name = res.data.name
          this.form.sex = res.data.sex
          this.form.idcard = res.data.idcard
          this.form.email = res.data.email
          this.subject_names = res.data.subject_names
        }
      })
    },
    onSubmit() {
      let ajaxData = {
        sex: this.form.sex,
        email: this.form.email,
        password: this.form.password
      }
      editInfo(ajaxData).then(res => {
        if (res.code == 1) {
          if (!this.form.password) {
            this.$message.success('修改成功！')
            this.getInfo()
          }else {
            localStorage.clear()
            this.$router.replace('/')
            this.$bus.$emit('refresh', {
              data: 1
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.dynamic-wrap {
  background: #fff;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;

  .tit {
    margin-top: 30px;
    color: #2257ab;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    padding: 30px 0;
    border-bottom: 1px solid #eee;
  }

  .kemu {
    width: 350px;
    color: #2257ab;
    font-weight: bold;
    font-size: 20px
  }
}

</style>
